import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { AvTableCard } from '../../../../Shared/Components/av-table-card/av-table-card.component';
import { exportToCsv } from '../../../../Shared/Utils/csv-export.utils';
import { ReportDetailDialogData } from '../../../models/report-dashboard.types';

@Component({
  selector: 'app-report-detail-dialog',
  standalone: true,
  imports: [COMMON_IMPORTS, AvTableCard],
  templateUrl: './report-detail-dialog.component.html',
  styleUrls: [
    './report-detail-dialog.component.scss',
    '../../../../../../assets/theme/cutom/_av-dialog.scss',
  ],
})
export class ReportDetailDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ReportDetailDialogComponent>);
  private readonly translate = inject(TranslateService);
  readonly data = inject(MAT_DIALOG_DATA) as ReportDetailDialogData;

  exportCsv(): void {
    const filename = this.translate.instant(this.data.titleKey);
    exportToCsv(filename, this.data.columns, this.data.rows, key => this.translate.instant(key));
  }

  close(): void {
    this.dialogRef.close();
  }
}
